import React, { useState, useEffect } from "react";
import SubNav from "../../../shared/subnav/SubNav";
import { withTranslation } from "react-i18next";
import HasPermissionTo from "../../../common/HasPermissionTo";
import DealerReporting from "./DealerReporting/DealerReporting";
import PendingActions from "../pendingActions/PendingActions";
import DealerNotifications from "../dealerNotifications/DealerNotifications";
import { displayError, LOAD_ERROR } from "../../../errors/ErrorConstants";

function DealerDashboard(props) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [renderApp, setRenderApp] = useState(false);
  const [hasError, setHasError] = useState([]);

  useEffect(() => {
    try {
      props.user.dashboardPage
        ? setSelectedTab(props.user.dashboardPage)
        : updateDashboardTab(selectedTab);
      setRenderApp(true);
    } catch {
      setHasError([LOAD_ERROR]);
    }
  }, []);

  const handleTabChange = (event, newSelectedTab) => {
    updateDashboardTab(newSelectedTab);
    setSelectedTab(newSelectedTab);
  };

  const updateDashboardTab = (newSelectedTab) => {
    props.user.updateDashboardTab &&
      props.user.updateDashboardTab(newSelectedTab);
  };

  const getTabs = () => {
    const tabs = [
      {
        menuName: props.t("ProgressBar.notifications"),
        enabled: true,
        id: "dashboard",
      },
    ];
    props.user.userType === "dealer" &&
      tabs.push({
        menuName: props.t("ProgressBar.reporting"),
        enabled: true,
        id: "reporting",
      });
    return tabs;
  };

  if (typeof props.hideOrShow !== "function") {
    console.warn(
      "[DealerDashboard] WARNING: hideOrShow is not a function or missing!",
      props.hideOrShow,
      props
    );
  }
  if (displayError(hasError)) throw new Error(hasError[0]);

  return (
    renderApp && (
      <div id="dashboard" className="pageWrapper">
        <HasPermissionTo
          perform={["dealerReporting:view"]}
          permissions={props.user.permissions.rolePermissions}
          render={() => {
            return (
              <SubNav
                dashboard={true}
                selectedTab={selectedTab}
                title={props.t("GlobalNavBar.dashboard")}
                action={handleTabChange}
                tabs={getTabs()}
                {...props}
              />
            );
          }}
          noRender={() => {
            return (
              <SubNav
                id="subNav"
                dashboard={true}
                title={props.t("GlobalNavBar.dashboard")}
                {...props}
              />
            );
          }}
        />
        {selectedTab === 0 ? (
          <>
            <HasPermissionTo
              perform={["pendingActionQueue:view"]}
              permissions={props.user.permissions.rolePermissions}
              render={() => <PendingActions {...props} />}
            />

            <HasPermissionTo
              perform={["notificationsQueue:view"]}
              permissions={props.user.permissions.rolePermissions}
              render={() => <DealerNotifications {...props} />}
            />
          </>
        ) : (
          <HasPermissionTo
            perform={["dealerReporting:view"]}
            permissions={props.user.permissions.rolePermissions}
            condition={selectedTab === 1}
            render={() => <DealerReporting {...props} />}
          />
        )}
      </div>
    )
  );
}

export default withTranslation("emp")(DealerDashboard);
